import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Auth/AuthProvider";
import MainNavBar from "./MainNavBar/MainNavBar";
import { dashboard } from "../routes";

export default function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const { routes, basePath } = dashboard;

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <>
      <MainNavBar routes={routes} basePath={basePath} />
      {children}
    </>
  );
}
